import React from "react";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import { LoyaltyBarSectionBox } from "./boxes/loyalty-bar-section.box";

@observer
export class LoyaltyBar extends OrbitComponent {
  render() {
    const showLoyaltyConfig = this.services.configuration.data.drawer.showLoyalty;
    if(!showLoyaltyConfig || !showLoyaltyConfig.display)
      return null;

    return (
      <LoyaltyBarSectionBox>
        <div className="cgp-directive-loyalty"
             onClick={() => this.services.userMenu.sendLoyaltyAnalytics()}
             data-backgroundcolor="transparent"
             data-showboxshadow="false"
             data-showunderline="false"
             data-fontsize="16"
             data-arrowsize="9"
             data-font="888, verdana, sans-serif"
             data-progressbarheight="4"
             data-arrowcolor="white"
             data-lolcontentpaddingleft="10px"
             data-lolarrowcontainerright="5px" />
      </LoyaltyBarSectionBox>
    );
  }
}
